import { MessageService } from '../services/message.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AccountService } from '../services/account.service';
import { RESET_PASSWORD_TOKEN } from '../models/auth-user.model';


@Injectable({ providedIn: 'root' })
export class ResetPasswordTokenGuard implements CanActivate {

    constructor(
        private router: Router,
        private accountService: AccountService,
        private messageService: MessageService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree | Observable<boolean | UrlTree> {

        if (route.queryParamMap.has(RESET_PASSWORD_TOKEN)) {
            const resetPasswordToken = route.queryParamMap.get(RESET_PASSWORD_TOKEN);
            return this.accountService.verifyOtp(resetPasswordToken, 'reset-password').pipe(
                map(() => {
                    return true;
                }),
                catchError(() => {
                    this.messageService.showError(`Link ripristino password scaduto`, `Errore`)
                    return of(this.router.createUrlTree(['/login']));
                }),
            );
        }

        return true;
    }
}
